/** Boost (repost) endpoint calls. Translations live under translationsApi — see endpoints/translations.ts. */
import { apiClient } from '../client'

export const boostsApi = {
  boost: (postId: string) =>
    apiClient.post(`/posts/${postId}/boost`).then((r) => r.data),

  deleteBoost: (boostId: string) =>
    apiClient.delete(`/boosts/${boostId}`).then((r) => r.data),
}
